import { render } from "./RegisterBeneficiaryForEvent.vue?vue&type=template&id=456a4eed"
import script from "./RegisterBeneficiaryForEvent.vue?vue&type=script&lang=js"
export * from "./RegisterBeneficiaryForEvent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__